export const games: string[] = [
    "Counter Strike",
    "Maplestory",
    "League of Legends",
    "DoTA",
    "Hearthstone",
    "Adventure Quest"
];